import { render } from "./speechvuerob.vue?vue&type=template&id=207bb1f4&scoped=true"
import script from "./speechvuerob.vue?vue&type=script&lang=js"
export * from "./speechvuerob.vue?vue&type=script&lang=js"

import "./speechvuerob.vue?vue&type=style&index=0&id=207bb1f4&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207bb1f4"]])

export default __exports__